import { e as __rest } from '../../../../tslib.es6-80f01feb.js';
import React__default from 'react';

var NavItem = function (_a) {
    var imageSrc = _a.imageSrc, text = _a.text, isActive = _a.isActive, _b = _a.alt, alt = _b === void 0 ? '' : _b, onClick = _a.onClick; __rest(_a, ["imageSrc", "text", "isActive", "alt", "onClick"]);
    return (React__default.createElement("div", { className: 'mobile-navigation-row-wr', onClick: onClick },
        React__default.createElement("div", { className: "mobile-navigation-row-item ".concat(isActive ? 'active' : '') },
            React__default.createElement("div", { className: 'mobile-navigation-row-item-top' },
                React__default.createElement("img", { className: 'menu-img', src: imageSrc, alt: alt })),
            React__default.createElement("div", { className: 'mobile-navigation-row-item-bottom' },
                React__default.createElement("p", { className: 'mobile-navigation-row-item-txt' }, text)))));
};

export { NavItem };
